angular.module('app.api').factory('apiLegacy', [
  '$http',
  function($http) {
    function makeRequest(methodToUse, urlToHit, DataToSend, headersToSend) {
      return $http({
        method: methodToUse,
        url: urlToHit,
        data: DataToSend,
        headers: headersToSend,
      })
    }

    var api = {
      request: makeRequest,
      fetchCurrentUser: () => {
        return $http.post('/api/fetch-current-user', {
          contentType: 'application/json',
        })
      },
      fetchSelectedLawyer: payload => {
        return makeRequest('POST', '/api/fetch-selected-lawyer', payload, {
          contentType: 'application/json',
        })
      },
      logoutUser: () => {
        return $http.post('/api/logout', {withCredentials: 'true'})
      },
      searchNonRegisterUsers: function(payload) {
        return $http.post('/api/fetch-search-non-registered-users', payload)
      },
      searchLawyers: function(payload) {
        // return makeRequest('POST', '/api/admin/fetchLawyers', payload, {gzip:true })
        return $http.post('/api/admin/fetchLawyers', payload)
      },
      setSelectedTabStateToLawyers: function() {
        return $http.post('/api/show-lawyers')
      },
      searchFirms: function(payload) {
        return $http.post('/api/admin/fetchFirms', payload)
      },
      setSelectedTabStateToFirms: function() {
        return $http.post('/api/show-firms')
      },
      setSelectedTabStateToInhouseJobs: function() {
        return $http.post('/api/show-inhouse-firms')
      },
      fetchEmailListings: function(page) {
        return $http.post('/api/admin/fetch-email-listing', page)
      },
      setSelectedTabStateToEmailListing: function() {
        return $http.post('/api/admin/navigate-email-listing')
      },
      fetchRelevantJobsCount: function(lawyers, regular) {
        return $http.post(
          '/api/fetch-relevant-roles-count',
          {lawyers: lawyers, isRegular: regular},
          {contentType: 'application/json'}
        )
      },
      fetchJobs: function(payload) {
        return $http.post(
          '/api/jobs/fetch-jobs-listing',
          {queryOptions: payload},
          {contentType: 'application/json'}
        )
      },
      fetchActiveJobs: function(payload) {
        return $http.post(
          '/api/jobs/fetch-active-jobs-listing',
          {queryOptions: payload},
          {contentType: 'application/json'}
        )
      },
      fetchExpiredJobs: function(payload) {
        return $http.post(
          '/api/jobs/fetch-expired-jobs-listing',
          {queryOptions: payload},
          {contentType: 'application/json'}
        )
      },
      updateAssignedAdmin: payload => {
        return $http.post('/api/update-user-assigned-admin', payload)
      },
      fetchAllConsultants: () => {
        return $http.post('/api/fetch-assignee-admins', {
          contentType: 'application/json',
        })
      },
      fetchRefSelectivities: () =>
        makeRequest('GET', '/api/fetch-ref-selectivity'),
      fetchRefCategories: () => makeRequest('POST', '/api/profile-category'),
      fetchRefPractices: () =>
        makeRequest('POST', '/api/profile-practice-areas'),
      fetchRefLocations: () => makeRequest('POST', '/api/profile-location'),
      updateUser: payload => {
        return $http.post('/api/update-user', payload, {
          contentType: 'application/json',
        })
      },
      getProfilePicture: payload => {
        return $http.post('/api/get-profile-pic', payload)
      },
      updateExpiryForMultipleJobs: payload => {
        return makeRequest(
          'POST',
          '/api/admin/updateMulitpleJobsExpiry',
          payload
        )
      },
      updateLocationsForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-locations', payload),
      updatePracticesForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-practices', payload),
      updateJurisdictionsForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-jurisdictions', payload),
      updateOtherJurisdictionsForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-otherJurisdictions', payload),
      updateLanguagesForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-languages', payload),
      updateOtherLanguagesForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-otherLanguages', payload),
      // updateShownFirmCategoriesForLawyer: (payload) => makeRequest('POST', '/api/update-lawyer-categories' , payload),
      updateMoveReasonForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-move', payload),
      updateAdditionalInfoForLawyer: payload =>
        makeRequest('POST', '/api/update-lawyer-info', payload),
      hideJobForLawyer: payload =>
        makeRequest('POST', '/api/hide-lawyer-job', payload),
      unHideJobForLawyer: payload =>
        makeRequest('POST', '/api/un-hide-lawyer-job', payload),
      hideEmployerForLawyer: payload =>
        makeRequest('POST', '/api/hide-lawyer-firm', payload),
      unHideEmployerForLawyer: payload =>
        makeRequest('POST', '/api/un-hide-lawyer-firm', payload),
      fetchLawyerSalary: payload =>
        makeRequest('POST', '/api/fetch-lawyer-salary', payload),
      fetchLawyerSalaryHistory: payload =>
        makeRequest('POST', '/api/fetch-lawyer-salary-history', payload),
      editLawyerSalary: payload =>
        makeRequest('POST', '/api/edit-lawyer-salary', payload),
      fetchAllLawyerContracts: payload =>
        makeRequest('POST', '/api/fetch-all-lawyer-contracts', payload),
      fetchAllLawyerRoles: payload =>
        makeRequest('POST', '/api/fetch-all-lawyer-roles', payload),
      fetchAllLawyerEmployerType: payload =>
        makeRequest('POST', '/api/fetch-all-lawyer-employer-type', payload),
      fetchLocations: payload =>
        makeRequest('POST', '/api/profile-location', payload),
      fetchPractices: payload =>
        makeRequest('POST', '/api/profile-practice-areas', payload),
      fetchAllContracts: payload =>
        makeRequest('POST', '/api/fetch-all-contracts', payload),
      fetchAllRoles: payload =>
        makeRequest('POST', '/api/fetch-all-roles', payload),
      fetchAllFirms: payload =>
        makeRequest('POST', '/api/fetchAllFirms', payload),
      // fetchLawyerLanguages: (payload) => makeRequest('POST', '/api/fetch-all-lawyer-languagesOtherLanguages' , payload),
      // fetchLawyerJurisdiction: (payload) => makeRequest('POST', '/api/fetch-all-lawyer-jurisdictionsOtherJurisdiction' , payload),
      updateLawyerPreferences: payload =>
        makeRequest('POST', '/api/update-lawyer-preferences', payload),
      updateLawyerPreferencesFlag: payload =>
        makeRequest('POST', '/api/update-lawyer-preferences-flag', payload),
      updateLawyerLinkedlin: payload =>
        makeRequest('POST', '/api/update-lawyer-linkedlin', payload),
      addLawyerSalary: payload =>
        makeRequest('POST', '/api/add-lawyer-salary', payload),
      fetchHeirarchyApplicationStages: payload =>
        makeRequest(
          'POST',
          '/api/stages/fetch-all-hierarchy-application-stages',
          payload
        ),
      fetchLinearApplicationStages: payload =>
        makeRequest(
          'POST',
          '/api/stages/fetch-all-linear-application-stages',
          payload
        ),
      fetchHeirarchyMatchesStages: payload =>
        makeRequest(
          'POST',
          '/api/stages/fetch-all-hierarchy-matches-stages',
          payload
        ),
      fetchLinearMatchesStages: payload =>
        makeRequest(
          'POST',
          '/api/stages/fetch-all-linear-matches-stages',
          payload
        ),
      fetchLastConversation: payload =>
        makeRequest('POST', '/api/fetch-last-conversation', payload),
      // updateJobListingType: (payload) => makeRequest( 'POST','/api/admin/updateJobListingType',payload ),

      addStage: payload =>
        makeRequest('POST', '/api/stages/insert-application-stage', payload),
      deleteStage: payload =>
        makeRequest('POST', '/api/stages/delete-application-stage', payload),
      updateStage: payload =>
        makeRequest('POST', '/api/stages/update-application-stage', payload),
      fetchApplicationRecordList: payload =>
        makeRequest('POST', '/api/admin/fetch-applications', payload),
      updateOrderStage: payload =>
        makeRequest(
          'POST',
          '/api/stages/update-order-application-stage',
          payload
        ),
      changeApplicationStage: payload =>
        makeRequest('POST', '/api/admin/change-application-stage', payload),
      fetchApplicationsCount: payload =>
        makeRequest('POST', '/api/admin/fetch-applications-count', payload),
      fetchApplicationHistory: payload =>
        makeRequest('POST', '/api/admin/fetch-application-history', payload),
      updateApplicationData: payload =>
        makeRequest('POST', '/api/admin/update-application-data', payload),
      updateApplicationHistory: payload =>
        makeRequest('POST', '/api/admin/update-application-history', payload),
      updateApplicationFollowers: payload =>
        makeRequest('POST', '/api/admin/update-application-followers', payload),
      updateApplicationHistoryNote: payload =>
        makeRequest(
          'POST',
          '/api/admin/update-application-history-note',
          payload
        ),
      deleteApplicationHistoryNote: payload =>
        makeRequest(
          'POST',
          '/api/admin/delete-application-history-note',
          payload
        ),
      deleteInterviewDate: payload =>
        makeRequest('POST', '/api/admin/delete-interview-date', payload),
      fetchSavedRulesForUsers: fetchFilterPayload => {
        return api.request(
          'POST',
          `/api/admin/applied-filters/fetch`,
          fetchFilterPayload
        )
      },
      saveFilter: filterPayload => {
        return api.request(
          'PUT',
          '/api/admin/applied-filters/save',
          filterPayload
        )
      },
      deleteSavedFilter: filterId => {
        return api.request(
          'DELETE',
          `/api/admin/applied-filters/delete/${filterId}`
        )
      },
      updateSavedFilter: (filterId, updatedFilterPayload) => {
        return api.request(
          'PUT',
          `/api/admin/applied-filters/save/${filterId}`,
          updatedFilterPayload
        )
      },
      fetchDefaultViewForUsers: fetchFilterPayload => {
        return api.request(
          'POST',
          `/api/admin/default-view-filter-user/fetch`,
          fetchFilterPayload
        )
      },
      deleteDefaultViewForUsers: fetchFilterPayload => {
        return api.request(
          'POST',
          `/api/admin/default-view-filter-user/delete`,
          fetchFilterPayload
        )
      },
      saveDefaultViewForUsers: fetchFilterPayload => {
        return api.request(
          'POST',
          `/api/admin/default-view-filter-user/save`,
          fetchFilterPayload
        )
      },
      fetchFirmByID: firmId => {
        return api.request('POST', '/api/admin/fetchFirmByID', firmId)
      },
      createEventHistory: payload =>
        makeRequest('POST', '/api/events/create-event', payload),

      changeMatchesStage: payload =>
        makeRequest('POST', '/api/admin/change-matches-stage', payload),
      changeMatchesStatus: payload =>
        makeRequest('POST', '/api/admin/change-matches-status', payload),
      fetchMatchesJob: payload =>
        makeRequest('POST', '/api/admin/fetch-matches-job', payload),
      fetchJobDescriptionById: payload =>
        makeRequest('POST', '/api/jobs/fetchJobDescriptionById', payload),

      fetchSearchNonRegisteredUsers: payload =>
        makeRequest('POST', '/api/fetch-search-non-registered-users', payload),
      fetchtotalReferredUsers: payload =>
        makeRequest('POST', '/api/fetch-total-referred-users', payload),
      fetchsuccessfulRefUsers: payload =>
        makeRequest('POST', '/api/fetch-successful-ref-users', payload),
      fetchNonRegisteredReferrals: payload =>
        makeRequest('POST', '/api/fetch-non-registered-referrals', payload),
      addErrorNotification: payload =>
        makeRequest('POST', '/api/notification/notifyError', payload),

      fetchMasterDetailApplications: payload =>
        makeRequest(
          'POST',
          '/api/admin/fetch-applications-matches-job',
          payload
        ),
    }
    return api
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/api/legacy.api.js